<template>
  <div id="map" style="height: 100vh; width: 100%"></div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
// import { mapLocation, getDeviceInfo } from '@/api/iemanage/drivers_screen'

export default {
  name: 'MapCenter',
  data() {
    return {
      map: null,
      markerLayer: null,
      geoLayer: null,
      clickLocked: false, // 3 秒点击锁
      hoverLocked: false, // 锁定标志：3秒内只能触发一次
      hoverTimer: null, // 解锁定时器
      detailPopup: null, // 用于悬浮窗 popup 控制
      pointDataInterval: null
    }
  },
  mounted() {
    // this.initMap()
  },
  beforeDestroy() {
    // clearInterval(this.pointDataInterval)
  },
  methods: {
    initMap() {
      this.map = L.map('map', {
        zoomControl: false, //放大缩小按钮
        attributionControl: false
      }).setView([31.2989, 120.5853], 10)

      // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      //   opacity: 0.3
      // }).addTo(this.map)

      // 矢量底图
      L.tileLayer(
        'https://t{s}.tianditu.gov.cn/vec_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&format=tiles&tileMatrix={z}&tileRow={y}&tileCol={x}&tk=e17a8af6a7274c09ceb3e3cbc45033da',
        {
          opacity: 0.3,
          subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
          attribution:
            '&copy; <a href="https://www.tianditu.gov.cn/">天地图</a>',
          maxZoom: 18
        }
      ).addTo(this.map)

      this.loadGeoJSON()
      // 每30分钟（1800000毫秒）轮询一次点位数据
      this.loadPointData() // 初始化加载一次
      this.pointDataInterval = setInterval(() => {
        this.loadPointData()
      }, 30 * 60 * 1000)
      // 1800000 毫秒 = 30 分钟
    },

    // 加载苏州行政区
    loadGeoJSON() {
      fetch('/map/suzhou.json')
        .then((res) => res.json())
        .then((geojson) => {
          this.geoLayer = L.geoJSON(geojson, {
            filter: (feature) => {
              const name =
                feature.properties.name || feature.properties.NAME || ''
              return (
                name.includes('区') ||
                name.includes('新区') ||
                name.includes('园区') ||
                name.includes('市')
              )
            },
            style: {
              color: '#005eb8', // 边界线颜色
              weight: 2, // 线宽
              dashArray: '5,6', // 虚线样式，5px 实线 + 5px 间隔
              fillColor: '#fff', // 区块填充色
              fillOpacity: 0.3 // 填充透明度
            },
            onEachFeature: (feature, layer) => {
              const name =
                feature.properties.name || feature.properties.NAME || '未知区域'
              const center = layer.getBounds().getCenter()

              const labelIcon = L.divIcon({
                className: 'district-label',
                html: `<div class="label-text" style="color:#005eb8">${name}</div>`,
                iconSize: [100, 24],
                iconAnchor: [50, 12]
              })

              // 添加区名
              L.marker(center, {
                icon: labelIcon,
                interactive: false
              }).addTo(this.map)

              // 悬浮变色
              layer.on({
                mouseover: (e) => {
                  e.target.setStyle({
                    weight: 2,
                    dashArray: '5,8', // 虚线样式，5px 实线 + 5px 间隔

                    color: '#005eb8',
                    fillColor: '#005eb8', // 区块填充色

                    fillOpacity: 0.3
                  })
                },
                mouseout: (e) => {
                  this.geoLayer.resetStyle(e.target)
                },
                click: () => {
                  this.map.flyToBounds(layer.getBounds(), {
                    duration: 0.8
                  })
                }
              })
            }
          }).addTo(this.map)

          // 初始视图适配苏州边界
          this.map.fitBounds(this.geoLayer.getBounds())
        })
        .catch((err) => {
          console.error('GeoJSON 加载失败:', err)
        })
    },

    // 加载点位（带图标）
    // loadPointData() {
    //   mapLocation({})
    //     .then((res) => {
    //       if (!res.data || !res.data.length) return

    //       if (this.markerLayer) {
    //         this.map.removeLayer(this.markerLayer)
    //       }

    //       this.markerLayer = L.layerGroup()

    //       res.data.forEach((item) => {
    //         const lat = parseFloat(item.latitude)
    //         const lng = parseFloat(item.longitude)

    //         if (!lat || !lng || isNaN(lat) || isNaN(lng)) return

    //         // 根据 online 字段选择图标
    //         const iconUrl =
    //           item.online == 1
    //             ? require('@/assets/icons/point-online.png')
    //             : require('@/assets/icons/point-offline.png')

    //         const customIcon = L.icon({
    //           iconUrl,
    //           iconSize: [32, 32],
    //           iconAnchor: [16, 32]
    //         })

    //         const marker = L.marker([lat, lng], { icon: customIcon })

    //         marker.on('click', () => {
    //           if (this.clickLocked) return

    //           this.clickLocked = true

    //           this.onPointClick(item.id, lat, lng)

    //           setTimeout(() => {
    //             this.clickLocked = false
    //           }, 1500)
    //         })
    //         // const marker = L.marker([lat, lng], { icon: customIcon })

    //         // // 鼠标移入显示详情（带3秒节流）
    //         // marker.on('mouseover', () => {
    //         //   if (this.hoverLocked) return

    //         //   this.hoverLocked = true
    //         //   this.fetchAndShowDetail(item.id, marker) // 请求接口 + 显示 popup

    //         //   // 3秒后允许再次请求
    //         //   this.hoverTimer = setTimeout(() => {
    //         //     this.hoverLocked = false
    //         //   }, 2000)
    //         // })

    //         // 鼠标移出关闭 popup
    //         marker.on('mouseout', () => {
    //           if (this.detailPopup) {
    //             this.map.closePopup(this.detailPopup)
    //             this.detailPopup = null
    //           }
    //         })

    //         // 可选：鼠标悬浮提示在线状态
    //         // marker.bindTooltip(item.online == 1 ? '在线' : '离线', {
    //         //   direction: 'top',
    //         //   offset: [0, -10],
    //         //   permanent: false
    //         // })

    //         marker.addTo(this.markerLayer)
    //       })

    //       this.markerLayer.addTo(this.map)
    //     })
    //     .catch((err) => {
    //       console.error('打点接口加载失败:', err)
    //     })
    // },
    // 点击点位，弹窗详情
    // onPointClick(id, lat, lng) {
    //   getDeviceInfo({ id })
    //     .then((res) => {
    //       if (res.data) {
    //         const detail = res.data
    //         const content = `
    //           <div style="min-width:180px">
    //             <strong>${detail.projectName || '无项目名'}</strong><br/>
    //             现场编号：${detail.internalNum || '暂无'}<br/>
    //             驾驶员：${this.showDrivers(detail.driverList)}<br/>
    //             <div id="detail-btn-${id}" style="color: #409eff;cursor: pointer;text-align:right;">详情</div>
    //           </div>
    //         `
    //         L.popup().setLatLng([lat, lng]).setContent(content).openOn(this.map)
    //         // 等弹窗渲染后再绑定按钮点击事件
    //         this.$nextTick(() => {
    //           const btn = document.getElementById(`detail-btn-${id}`)
    //           if (btn) {
    //             btn.addEventListener('click', () => {
    //               this.handleDriverInfo(detail) // 你可以改为路由跳转或其他逻辑
    //             })
    //           }
    //         })
    //       }
    //     })
    //     .catch((err) => {
    //       console.error('详情接口加载失败:', err)
    //     })
    // },
    // 驾驶信息
    handleDriverInfo(row) {
      this.$router.push(`/iemanage/driver-info/device/${row.id}`)
    },
    showDrivers(driverList) {
      if (!Array.isArray(driverList) || driverList.length === 0) {
        return '暂无'
      }
      return driverList
        .map((d) => d.driverName)
        .filter(Boolean)
        .join('，')
    }
    // fetchAndShowDetail(id, marker) {
    //   // 示例请求 detail 接口
    //   getDeviceInfo({ id })
    //     .then((res) => {
    //       const detailInfo = res.data || {}
    //       const content = `<div style="min-width:120px;font-size:14px;">
    //       <strong>${detailInfo.projectName || '无名称'}</strong><br/>
    //       现场编号：${detailInfo.internalNum || '未知'}
    //     </div>`

    //       this.detailPopup = L.popup({
    //         closeButton: false,
    //         autoClose: false,
    //         offset: [0, -20]
    //       })
    //         .setLatLng(marker.getLatLng())
    //         .setContent(content)
    //         .openOn(this.map)
    //     })
    //     .catch((err) => {
    //       console.error('详情接口加载失败:', err)
    //     })
    // }
  }
}
</script>

<style scoped>
.district-label {
  pointer-events: none;
  text-align: center;
}

.label-text {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  background: rgba(0, 120, 215, 0.85);
  padding: 2px 8px;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  color: #005eb8;
}
</style>
